import { NavigateFunction } from "react-router-dom";
import { ThunkActionDispatch } from "redux-thunk";
import { resetAuth } from "store/auth";
import { resetDeposit } from "store/deposit";
import { resetWithdrawalOrders } from "store/orders";
import { resetUser } from "store/user";
import { resetWithdraw } from "store/withdraw";

export const handleResetData = (
  dispatch: ThunkActionDispatch<any>,
  navigate: NavigateFunction,
) => {
  dispatch(resetAuth());
  dispatch(resetUser());
  dispatch(resetDeposit());
  dispatch(resetWithdrawalOrders());
  dispatch(resetWithdraw());

  localStorage.clear();
  navigate("/");
};
